import InputProps from '../../Inputs/Input.interface'
import React, { ReactElement, useState } from 'react'
import useGetUser from '../../../components/Dashboard/utils/useGetUser'
import PasswordInput from '../../../components/PasswordInput'

export default function ConfirmDeletionPassword({
  onChange,
}: Pick<InputProps, 'onChange'>): ReactElement {
  const [showPassword, setShowPassword] = useState(false)

  const { data } = useGetUser()
  const isSSO = !!data?.sso
  const isOrg = !!data?.org

  return (
    <PasswordInput
      isCompact
      type={showPassword ? 'text' : 'password'}
      id="password-input"
      data-testid="password-input"
      name={isSSO ? (isOrg ? 'organization-name' : 'email-address') : 'password'}
      label={isSSO ? (isOrg ? 'Organization Name' : 'Email Address') : 'Password'}
      onChange={onChange}
      aria-label={
        isSSO
          ? isOrg
            ? 'enter the organization name to confirm deletion'
            : 'enter the email address to confirm deletion'
          : 'enter the password to confirm deletion '
      }
      sxShowPasswordStyle={{
        bottom: '0.8rem',
        right: '1.2rem',
      }}
      showPassword={showPassword}
      setShowPassword={setShowPassword}
      shouldShowShowPasswordButton
      autoComplete="off"
    />
  )
}
